import { createAccount, updateAccount } from "graphql/mutations";
import { getAccount } from "graphql/queries";
import {
  updateLoader,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { store } from "Store/store";
import { ExecuteMutation, ExecuteQuery } from "Utility/Api";

export const createAccountAction = (input) => {
  return ExecuteMutation(createAccount, { input });
};

export const updateAccountDetails = async (input) => {
  let updatedInput = { ...input, isDraft: true };
  try {
    store.dispatch(updateUserDetailsInReducer(input));
    store.dispatch(updateLoader(true));
    var res = await ExecuteMutation(updateAccount, { input: updatedInput });
    store.dispatch(updateUserDetailsInReducer(res));
    store.dispatch(updateLoader(false));
  } catch (error) {
    console.log(error);
  }
  return res;
};

export const getAccountDetails = async (username) => {
  try {
    // store.dispatch(updateLoader(true));
    var res = await ExecuteQuery(getAccount, { username });
    store.dispatch(updateUserDetailsInReducer(res));
    store.dispatch(updateLoader(false));
  } catch (error) {
    console.log(error);
  }
  return res;
};
